<template>
  <v-autocomplete
    v-bind="this.$attrs"
    item-text="name"
    item-value="id"
    :items="teachers"
    return-object
    @change="onChange"
    v-on:input="$emit('input', $event)"
    clearable
    :loading="loading"
    v-model="teacher"
  >
    <template v-slot:item="data">
      <v-list-item-content>
        <CardTeacherInfo
          :displayGender="displayGender"
          :teacher="data.item"
          :displaySubjectGroup="displaySubjectGroup"
        />
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { Teacher } from '@/plugins/api'
import CardTeacherInfo from '@/components/basic/card/CardTeacherInfo.vue'

export default {
  components: {
    CardTeacherInfo
  },
  data: () => ({
    teachers: [],
    loading: false,
    teacher: ''
  }),
  props: {
    filter: Object,
    options: Object,
    defaultTeachers: Object,
    defaultTeacher: Object,
    displayGender: {
      default: false,
      type: Boolean
    },
    displaySubjectGroup: {
      default: false,
      type: Boolean
    },
    syncedValue: Object
  },
  watch: {
    filter(filter) {
      this.fetchAllTeachers()
    },
    syncedValue: {
      handler(value) {
        this.teacher = value
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    if (this.defaultTeachers) {
      this.teachers = this.defaultTeachers
    }
    this.fetchHeadTeachers()
  },
  methods: {
    async fetchHeadTeachers() {
      this.loading = true
      this.teachers = await Teacher.fetch({
        ...this.filter,
        _sort: 'nameToNumber:ASC',
        _limit: -1
      })
      if (this.defaultTeacher) {
        this.teachers = this.teachers.filter(item => item.id !== this.defaultTeacher.id && item.ownClasses.length > 0)
      } else {
        this.teachers = this.teachers.filter(item => item.ownClasses.length > 0)
      }
      this.loading = false
    },
    onChange(data) {
      this.$emit('update:syncedValue', data)
      this.$emit('change', data)
    }
  }
}
</script>
